import { createSelector } from 'reselect'

export const getCountriesLoading = createSelector(
  (state) => Boolean(state.geoObjects && state.geoObjects.countries && state.geoObjects.countries.isLoading),
  (isLoading) => isLoading
)
